import { MULTIPART_HEADERS } from '../helpers';
import {
  BrandTemplateEntity,
  BTImportMenuUrlPreviewResponse,
  BTMenuResponse,
  BTMenuWithTemplateResponse,
  CreateBTMenuCategoryDto,
  CreateBTMenuModifierDto,
  UpdateBTMenuCategoryDto,
  UpdateBTMenuListOrdersDto,
  UpdateBTMenuModifierGroupDto,
} from '../types/brand.types';
import { ItemType } from '../types/menu.types';
import { PaginationParams, ResponseType } from '../types/shared.types';
import { api } from './api';

export const createBrandTemplate = (data: FormData) =>
  api.post<ResponseType<BrandTemplateEntity>>(
    `/v1/brand-templates`,
    data,
    MULTIPART_HEADERS
  );

export const getBrandTemplates = (
  params: PaginationParams<{ query?: string | null }>
) =>
  api.get<ResponseType<BrandTemplateEntity[]>>(`/v1/brand-templates`, {
    params,
  });

export const migrateBT = () =>
  api.patch<ResponseType<null>>(`/v1/brand-templates`);

export const updateBrandTemplatePhone = (
  id: string | number,
  phoneNumber: string
) =>
  api.put<ResponseType<BrandTemplateEntity>>(
    `/v1/brand-templates/${id}/phone-number`,
    { phoneNumber }
  );

export const updateBrandTemplate = (id: string | number, data: FormData) =>
  api.put<ResponseType<BrandTemplateEntity>>(
    `/v1/brand-templates/${id}`,
    data,
    MULTIPART_HEADERS
  );

export const deleteBrandTemplate = (id: string | number) =>
  api.delete<ResponseType<null>>(`/v1/brand-templates/${id}`);

export const getBrandTemplateMenu = (brandTemplateId: string) =>
  api.get<ResponseType<BTMenuWithTemplateResponse>>(
    `/v1/brand-templates/${brandTemplateId}/menu`
  );

export const updateBrandTemplateMenuItem = (
  brandTemplateId: string | number,
  itemId: string | number,
  data: FormData
) =>
  api.put<ResponseType<BTMenuResponse>>(
    `/v1/brand-templates/${brandTemplateId}/menu/item/${itemId}`,
    data,
    MULTIPART_HEADERS
  );

export const addBrandTemplateMenuItem = (
  brandTemplateId: string | number,
  data: FormData
) =>
  api.post<ResponseType<BTMenuResponse>>(
    `/v1/brand-templates/${brandTemplateId}/menu/item`,
    data,
    MULTIPART_HEADERS
  );

export const deleteBrandTemplateMenuTypeItemById = (
  brandTemplateId: string | number,
  id: string | number,
  type: ItemType
) =>
  api.delete<ResponseType<BTMenuResponse>>(
    `/v1/brand-templates/${brandTemplateId}/menu/delete/${id}/${type}`
  );

export const createBrandTemplateMenuModifierGroup = (
  brandTemplateId: string | number,
  data: CreateBTMenuModifierDto
) =>
  api.post<ResponseType<BTMenuResponse>>(
    `/v1/brand-templates/${brandTemplateId}/menu/modifier-group`,
    data
  );

export const updateBrandTemplateMenuModifierGroup = (
  brandTemplateId: string | number,
  id: string | number,
  data: UpdateBTMenuModifierGroupDto
) =>
  api.put<ResponseType<BTMenuResponse>>(
    `/v1/brand-templates/${brandTemplateId}/menu/modifier-group/${id}`,
    data
  );

export const createBrandTemplateMenuCategory = (
  brandTemplateId: string | number,
  data: CreateBTMenuCategoryDto
) =>
  api.post<ResponseType<BTMenuResponse>>(
    `/v1/brand-templates/${brandTemplateId}/menu/category`,
    data
  );

export const updateBrandTemplateMenuCategory = (
  brandTemplateId: string | number,
  id: string | number,
  data: UpdateBTMenuCategoryDto
) =>
  api.put<ResponseType<BTMenuResponse>>(
    `/v1/brand-templates/${brandTemplateId}/menu/category/${id}`,
    data
  );

export const importBrandTemplateMenuFromURL = (
  brandTemplateId: string | number,
  url: string
) =>
  api.post<ResponseType<BTImportMenuUrlPreviewResponse>>(
    `/v1/brand-templates/${brandTemplateId}/menu/preview-url`,
    {
      url,
    }
  );

export const cancelBrandTemplateMenuImportFromUrl = (
  brandTemplateId: string | number,
  url: string
) =>
  api.post<ResponseType<null>>(
    `/v1/brand-templates/${brandTemplateId}/menu/cancel-preview-url`,
    {
      url,
    }
  );

export const importBrandTemplateMenuFromAnotherProvider = (
  brandTemplateId: string | number,
  data: any
) =>
  api.post<ResponseType<BTMenuResponse>>(
    `/v1/brand-templates/${brandTemplateId}/menu/import`,
    data
  );

export const uploadBrandTemplateMenuImportPreviewImage = (
  brandTemplateId: string | number,
  data: FormData
) =>
  api.post<ResponseType<string>>(
    `/v1/brand-templates/${brandTemplateId}/menu/import-image`,
    data,
    {
      headers: { 'content-type': 'multipart/form-data' },
    }
  );

export const updateBrandTemplateMenuItemImage = (data: FormData) =>
  api.post<ResponseType<string>>(`v2/brands/templates/temp-image`, data, {
    headers: { 'content-type': 'multipart/form-data' },
  });

export const updateBrandTemplateMenuCategoryOrder = (
  brandTemplateId: string | number,
  list: UpdateBTMenuListOrdersDto[]
) =>
  api.put<ResponseType<BTMenuResponse>>(
    `/v1/brand-templates/${brandTemplateId}/menu/category/order`,
    { list }
  );

export const updateBrandTemplateMenuItemOrder = (
  brandTemplateId: string | number,
  categoryId: number,
  list: UpdateBTMenuListOrdersDto[]
) =>
  api.put<ResponseType<BTMenuResponse>>(
    `/v1/brand-templates/${brandTemplateId}/menu/category/order/${categoryId}/items`,
    { list }
  );
